/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from "underscore";

import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import Button from "../elements/button";

export default class ModalFooterWithButtons extends React.Component {
  static displayName = "ModalFooterWithButtons";

  static propTypes = {
    className: PropTypes.string,
    type: PropTypes.string,
    saveLabel: PropTypes.any,
    cancelLabel: PropTypes.any,
    disableSave: PropTypes.bool,
    disableCancel: PropTypes.bool,
    closeOnSubmit: PropTypes.bool,
    closeModal: PropTypes.func,
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func,
    rightChildren: PropTypes.any,
  };

  static defaultProps = {
    type: "default",
    saveLabel: "Save",
    cancelLabel: "Cancel",
    closeOnSubmit: true,
  };

  handleSubmit = () => {
    if (_.isFunction(this.props.onSubmit) && !this.props.disableSave) {
      this.props.onSubmit();
      if (this.props.closeOnSubmit) {
        return this.handleHide();
      }
    }
  };

  handleCancel = () => {
    if (!this.props.disableCancel) {
      if (typeof this.props.onCancel === "function") {
        this.props.onCancel();
      }
      return this.handleHide();
    }
  };

  handleHide = () => {
    return typeof this.props.closeModal === "function" ? this.props.closeModal() : undefined;
  };

  render() {
    return (
      <div className={classNames("et--modal-footer-with-buttons", this.props.className)}>
        {this.props.children ? (
          <div className="et--modal-footer-with-buttons--children">{this.props.children}</div>
        ) : undefined}
        <div className="et--modal-footer-with-buttons--buttons">
          {this.props.onCancel ? (
            <Button
              type="secondary"
              disabled={this.props.disableCancel}
              className="et--modal-footer-with-buttons--cancel"
              onClick={this.handleCancel}
            >
              {this.props.cancelLabel}
            </Button>
          ) : undefined}
          {this.props.onSubmit ? (
            <Button
              type={this.props.type}
              disabled={this.props.disableSave}
              onClick={this.handleSubmit}
              className="et--modal-footer-with-buttons--submit"
            >
              {this.props.saveLabel}
            </Button>
          ) : undefined}
        </div>
        {this.props.rightChildren && (
          <div className="et--modal-footer-with-buttons--children">{this.props.rightChildren}</div>
        )}
      </div>
    );
  }
}
